import React from 'react';

function Input({ className = '', ...props }) {
  return (
    <input
      className={`h-10 w-full px-3 rounded-lg border border-[var(--axial-border)] bg-[var(--axial-surface)] text-[var(--axial-text-primary)] placeholder-[var(--axial-text-muted)] focus:outline-none focus:ring-2 focus:ring-[var(--axial-primary)] ${className}`}
      {...props}
    />
  );
}

export default Input;
